<template>
  <v-parallax height="430" :src="isCarousel ? '' : require('@/assets/banner/dots.svg')" alt>
    <TopStrip>
      <v-container>
        <Search v-if="fix"/>
        <v-row
          v-else
          class="align-center"
        >
          <v-col
            :lg="slogan?.length || isCarousel ? 5 : 12"
            sm="12"
            class="pa-0"
          >
            <h1
              v-if="isCarousel"
              class="d-flex
              primary-color
              font-weight-semibold
              justify-center
              text-uppercase
              e2e-storename"
              style="font-size: 20px"
            >
              {{ wait(storeInfo, "name") }}
            </h1>
            <StoreAddress
              :lines="1"
              v-else
            />
          </v-col>
          <v-col
              lg="5"
              offset-lg="2"
              sm="12"
              offset-sm="0"
              class="d-md-flex pa-0"
          >
            <div
                class="slogan"
                :class="$vuetify.breakpoint.lg ? 'text-left' : 'text-center'"
                style="width: 100%"
            >
              {{ slogan }}
            </div>
          </v-col>
        </v-row>
      </v-container>
    </TopStrip>
    <StorefrontImage :size="isCarousel ? 'carousel' : 'large'" :style="StorefrontImageStyle"/>
    <v-container fluid>
      <v-row no-gutters>
        <v-col
            cols="12"
            class="d-flex justify-center"
            :style="{height: isCarousel ? 'auto' : '150px'}"
        >
          <BannerCarousel v-if="isCarousel" />
        </v-col>
        <v-col cols="12" v-if="!isCarousel">
          <h1
            class="
              d-flex 
              color-black-magic
              font-size-xl font-weight-semibold
              justify-center
              text-uppercase
              e2e-storename
            "
          >{{ wait(storeInfo, "name") }}</h1>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        :class="{'mt-0': isCarousel, 'mb-3': isCarousel}"
      >
        <v-col
          cols="8"
          lg="7"
          xl="5"
          :class="{'pa-0': isCarousel, 'mt-2': isCarousel}"
        >
          <Search />
        </v-col>
      </v-row>
      <Navigation :fix="fix" :navTabs="navTabs" />
    </v-container>
  </v-parallax>
</template>

<script>
import { mapState } from "vuex";
import { wait } from "@/util.js";
import Navigation from "@/components/Navigation/index.vue";
import Search from "@/components/Search/index.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";
import StoreAddress from '@/components/TopStrip/StoreAddress.vue'
import TopStrip from '@/components/TopStrip/index.vue'
import BannerCarousel from '@/components/BannerCarousel/BannerCarousel.vue'

export default {
  name: "Header",
  components: {BannerCarousel, TopStrip, StoreAddress, Navigation, Search, StorefrontImage },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
      slogan: (state) => state.store.info.store_info.customization?.website.style.slogan,
      isCarousel: (state) => state.store.info.store_info.customization?.website.banner.isCarousel,
    }),
    StorefrontImageStyle() {
      return {
        position: 'absolute',
        top: this.isCarousel ? (this.$vuetify.breakpoint.mdAndDown ? '128px' : '4px') : '76px',
        left: this.isCarousel ? (this.$vuetify.breakpoint.mdAndDown ? '30px' : 'calc((100% - 120px) / 2)') : 'calc((100% - 152px) / 2)',
        zIndex: (this.isCarousel && this.$vuetify.breakpoint.lgAndUp) ? 10 : 0,
      }
    }
  },
  methods: { wait },
  props: { fix: Boolean, navTabs: Array },
};
</script>
